<script>
    import { getContext } from 'svelte';
    import { publishOpenAction } from './openable';
    import CopyButton from '../CopyButton.svelte';
    import PlaygroundHelper from '../scripts/playgroundhelper';
    import FormatHelper from '../scripts/FormatHelper';

    export let photoEdit;
    $: playground = photoEdit ? photoEdit.playground : null;
    $: playgroundTitle = PlaygroundHelper.presentPlayground(playground);

    // Lets the sidebar open the item from the keyboard
    $: publishOpenAction(photoEdit, action);

    export let photoEditHandled;

    let getMap = getContext('getMap');

    function photoEditClosed() {
        if (!photoEdit || !photoEditHandled) {
            return;
        }

        if (photoEdit.metadata.state == 'open') {
            return;
        }

        photoEditHandled(photoEdit);
    }

    function action() {
        getMap().openApprovePhotoEditPopup(photoEdit, photoEditClosed);
    }

</script>

<p>
    <!-- svelte-ignore a11y-invalid-attribute -->
    <a class="removal" href="#" on:click|preventDefault={action}>Ta bort foto: {playgroundTitle}</a>
</p>
<p class="small-line">
    {FormatHelper.dateTime(photoEdit.metadata.created)}
</p>
<p class="small-line">
    <i class="far fa-image" />
    {photoEdit.photo._id}<CopyButton text={photoEdit.photo._id} />
</p>

<style>
    p {
        margin: 0;
        padding: 0;
    }

    p.small-line {
        font-size: 12px;
    }

    a.removal {
        color: #dc3545;
    }
</style>
